import React from 'react';

import { PaywallScreens } from '~analytics/types';
import { QuizEditorFileUploadPaywall } from '~teacher/components/QuizEditor/QuizEditorFileUploadPaywall';

import { extractQuestionsPaywallAtom } from './atoms';

export function PaywallDialogExtractQuestionsFromDoc() {
  return (
    <QuizEditorFileUploadPaywall
      id="paywall-extract-questions-from-doc"
      title="Upgrade to Extract Questions from Document"
      description="Easily add questions by uploading documents like quizzes, answer keys, and worksheets."
      paywallScreen={PaywallScreens.QuizEditExtractQuestions}
      paywallAtom={extractQuestionsPaywallAtom}
    />
  );
}
